// dashboard — see README.md. Keys must exist in BOTH maps (checked by npm run check:locales).
export const en = {
  // --- Dashboard landing page ----------------------------------------------
  'dashboard.welcomeHeading': 'Welcome to RestoBoxx!',
  'dashboard.feature.staffManagement': 'Staff Management',
  'dashboard.feature.userTracking': 'User Tracking',
  'dashboard.feature.orders': 'Orders',
  'dashboard.feature.inventory': 'Inventory',
  'dashboard.feature.staff': 'Staff',
  'dashboard.feature.analytics': 'Analytics',
  'dashboard.open': 'Open',
  'dashboard.accessRestricted': 'Access Restricted',
  'dashboard.profile.title': 'Your Profile',
  'dashboard.profile.email': 'Email',
  'dashboard.profile.username': 'Username',
  'dashboard.profile.phone': 'Phone',
  'dashboard.profile.notProvided': 'Not provided',

  // --- Access denied card (AccessDenied.jsx) -------------------------------
  'dashboard.accessDenied.title': 'Access denied',
  'dashboard.accessDenied.thisPage': 'this page',
  'dashboard.accessDenied.body': 'Your role does not have permission to view {what}.',
  // Split around the <code> chip holding the permission code, so each language
  // can put the chip where its own word order needs it.
  'dashboard.accessDenied.askAdminPrefix': 'Ask an administrator to grant the',
  'dashboard.accessDenied.askAdminSuffix': 'permission to your role.',

  // --- Welcome tips toast ---------------------------------------------------
  'dashboard.welcomeTips.hi': 'Hi, {name} 👋',
  'dashboard.welcomeTips.there': 'there',
  'dashboard.welcomeTips.dismiss': 'Dismiss welcome tips',
  // Split around the bold RestoBoxx wordmark in the intro sentence.
  'dashboard.welcomeTips.intro': 'Glad to have you back at',
  'dashboard.welcomeTips.introEnd': 'A few quick places you can start:',
  'dashboard.welcomeTips.menu.title': 'Build your menu',
  'dashboard.welcomeTips.menu.body': 'Jump to Menu → Create Menu to add your first dishes.',
  'dashboard.welcomeTips.team.title': 'Add your team',
  'dashboard.welcomeTips.team.body': 'Staff → All Staff lets you onboard waiters, cooks, and managers.',
  'dashboard.welcomeTips.settings.title': 'Tune your settings',
  'dashboard.welcomeTips.settings.body': 'Settings → Company Profile holds your business identity and tax IDs.',
  'dashboard.welcomeTips.roles.title': 'Define who sees what',
  'dashboard.welcomeTips.roles.body': 'Staff → Roles is where you control per-module permissions.',
  'dashboard.welcomeTips.gotIt': 'Got it',

  // --- Notification bell ----------------------------------------------------
  'dashboard.notif.title': 'Notifications',
  'dashboard.notif.mutedSuffix': '(muted)',
  'dashboard.notif.unreadSuffix': '({count} unread)',
  'dashboard.notif.bellTitleMuted': 'Notifications — muted on this device (badge still counts)',
  'dashboard.notif.markAllRead': 'Mark all read',
  'dashboard.notif.muteOnTitle': 'Popups and the chime are off on this device — the badge still counts. Click to turn them back on.',
  'dashboard.notif.muteOffTitle': 'Silence the popups and chime on this device — the badge still counts.',
  'dashboard.notif.mute': 'Mute',
  'dashboard.notif.unmute': 'Unmute',
  'dashboard.notif.mutedBanner': 'Muted on this device — no chime, no popups. New requests still land here and on the badge.',
  'dashboard.notif.empty': 'All caught up — nothing needs your attention.',
  'dashboard.notif.reservationRequest': 'Reservation request',
  'dashboard.notif.pax': 'pax',
  'dashboard.notif.buffet': 'Buffet',
  'dashboard.notif.approve': 'Approve',
  'dashboard.notif.reject': 'Reject',
  'dashboard.notif.approveKeepsTable': 'Approve — keeps table {table}',
  'dashboard.notif.approveTitle': 'Approve this booking',
  'dashboard.notif.declineTitle': 'Decline this reservation?',
  'dashboard.notif.declineBody': '{who} · {pax} pax — the booking will be cancelled and the guest loses the table.',
  'dashboard.notif.declineConfirm': 'Decline booking',
  'dashboard.notif.approved': 'Reservation approved',
  'dashboard.notif.declined': 'Reservation declined',
  'dashboard.notif.error': 'Error',
  'dashboard.notif.failed': 'Failed',

  // --- Shared confirm / alert dialog defaults -------------------------------
  'dashboard.dialog.confirm': 'Confirm',
  'dashboard.dialog.cancel': 'Cancel',
  'dashboard.dialog.ok': 'OK',
  'dashboard.dialog.areYouSure': 'Are you sure?',
  'dashboard.dialog.pleaseConfirm': 'Please confirm',
  'dashboard.dialog.error': 'Error',
  'dashboard.dialog.notice': 'Notice',
};

export const fr = {
  // --- Dashboard landing page ----------------------------------------------
  'dashboard.welcomeHeading': 'Bienvenue sur RestoBoxx !',
  'dashboard.feature.staffManagement': 'Gestion du personnel',
  'dashboard.feature.userTracking': 'Suivi des utilisateurs',
  'dashboard.feature.orders': 'Commandes',
  'dashboard.feature.inventory': 'Stock',
  'dashboard.feature.staff': 'Personnel',
  'dashboard.feature.analytics': 'Statistiques',
  'dashboard.open': 'Ouvrir',
  'dashboard.accessRestricted': 'Accès restreint',
  'dashboard.profile.title': 'Votre profil',
  'dashboard.profile.email': 'E-mail',
  'dashboard.profile.username': 'Nom d\'utilisateur',
  'dashboard.profile.phone': 'Téléphone',
  'dashboard.profile.notProvided': 'Non renseigné',

  // --- Access denied card (AccessDenied.jsx) -------------------------------
  'dashboard.accessDenied.title': 'Accès refusé',
  'dashboard.accessDenied.thisPage': 'cette page',
  'dashboard.accessDenied.body': 'Votre rôle n\'a pas l\'autorisation de consulter {what}.',
  // Split around the <code> chip holding the permission code, so each language
  // can put the chip where its own word order needs it.
  'dashboard.accessDenied.askAdminPrefix': 'Demandez à un administrateur d\'accorder l\'autorisation',
  'dashboard.accessDenied.askAdminSuffix': 'à votre rôle.',

  // --- Welcome tips toast ---------------------------------------------------
  'dashboard.welcomeTips.hi': 'Bonjour {name} 👋',
  'dashboard.welcomeTips.there': 'à vous',
  'dashboard.welcomeTips.dismiss': 'Fermer les conseils de bienvenue',
  // Split around the bold RestoBoxx wordmark in the intro sentence.
  'dashboard.welcomeTips.intro': 'Ravi de vous revoir sur',
  'dashboard.welcomeTips.introEnd': 'Voici quelques points de départ :',
  'dashboard.welcomeTips.menu.title': 'Composez votre menu',
  'dashboard.welcomeTips.menu.body': 'Allez dans Menu → Créer un menu pour ajouter vos premiers plats.',
  'dashboard.welcomeTips.team.title': 'Ajoutez votre équipe',
  'dashboard.welcomeTips.team.body': 'Personnel → Liste du personnel permet d\'enregistrer serveurs, cuisiniers et managers.',
  'dashboard.welcomeTips.settings.title': 'Réglez vos paramètres',
  'dashboard.welcomeTips.settings.body': 'Paramètres → Profil de l\'entreprise contient votre identité commerciale et vos numéros fiscaux.',
  'dashboard.welcomeTips.roles.title': 'Définissez qui voit quoi',
  'dashboard.welcomeTips.roles.body': 'Personnel → Rôles vous permet de gérer les autorisations par module.',
  'dashboard.welcomeTips.gotIt': 'Compris',

  // --- Notification bell ----------------------------------------------------
  'dashboard.notif.title': 'Notifications',
  'dashboard.notif.mutedSuffix': '(en sourdine)',
  'dashboard.notif.unreadSuffix': '({count} non lues)',
  'dashboard.notif.bellTitleMuted': 'Notifications — en sourdine sur cet appareil (le compteur reste actif)',
  'dashboard.notif.markAllRead': 'Tout marquer comme lu',
  'dashboard.notif.muteOnTitle': 'Les fenêtres et le signal sonore sont coupés sur cet appareil — le compteur reste actif. Cliquez pour les réactiver.',
  'dashboard.notif.muteOffTitle': 'Couper les fenêtres et le signal sonore sur cet appareil — le compteur reste actif.',
  'dashboard.notif.mute': 'Couper',
  'dashboard.notif.unmute': 'Réactiver',
  'dashboard.notif.mutedBanner': 'En sourdine sur cet appareil — ni son ni fenêtre. Les nouvelles demandes arrivent toujours ici et sur le compteur.',
  'dashboard.notif.empty': 'Tout est à jour — rien ne demande votre attention.',
  'dashboard.notif.reservationRequest': 'Demande de réservation',
  'dashboard.notif.pax': 'couverts',
  'dashboard.notif.buffet': 'Buffet',
  'dashboard.notif.approve': 'Approuver',
  'dashboard.notif.reject': 'Refuser',
  'dashboard.notif.approveKeepsTable': 'Approuver — conserve la table {table}',
  'dashboard.notif.approveTitle': 'Approuver cette réservation',
  'dashboard.notif.declineTitle': 'Refuser cette réservation ?',
  'dashboard.notif.declineBody': '{who} · {pax} couverts — la réservation sera annulée et le client perdra la table.',
  'dashboard.notif.declineConfirm': 'Refuser la réservation',
  'dashboard.notif.approved': 'Réservation approuvée',
  'dashboard.notif.declined': 'Réservation refusée',
  'dashboard.notif.error': 'Erreur',
  'dashboard.notif.failed': 'Échec',

  // --- Shared confirm / alert dialog defaults -------------------------------
  'dashboard.dialog.confirm': 'Confirmer',
  'dashboard.dialog.cancel': 'Annuler',
  'dashboard.dialog.ok': 'OK',
  'dashboard.dialog.areYouSure': 'Êtes-vous sûr ?',
  'dashboard.dialog.pleaseConfirm': 'Merci de confirmer',
  'dashboard.dialog.error': 'Erreur',
  'dashboard.dialog.notice': 'Information',
};
